import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Slot                          } from 'src/app/beans/slot/slot.bean';
import { Service } from 'src/app/beans/service/service.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { Result } from 'src/app/beans/result/result.bean';
import { AngularDeviceInformationService } from 'angular-device-information';
import { version } from 'src/environments/version';

@Component
({
  selector: 'slot-prenotation-dialog',
  templateUrl: './slot.prenotation.dialog.html',
  styleUrls: ['./slot.prenotation.dialog.scss'],
})

export class SlotPrenotationDialog implements OnInit
{
  site    : Site
  service : Service

  _slot   : Slot
  date    : String

  isAQP = false

  constructor
    (
      private dialogRef: MatDialogRef<SlotPrenotationDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _util   : UtilsManager  ,
      private _handler: HandlerManager,
      private _loader : LoadingManager,
      private _session: SessionManager,
      private _deviceInfo: AngularDeviceInformationService
  ) { }

  ngOnInit(): void
  {
    this.site     = this.data.site
    this.service  = this.data.service
    this._slot    = this.data.slot
    this.date     = this.data.date
    this.isAQP    = this.site.organizationId == 200
    console.log(this.isAQP);

  }

  //---------------------------------------------------------------------------------------------------

  async create()
  {
    let response = await this.changeValue("create")

    this.acceptOperation(response)
  }

  async update()
  {
    let response = await this.changeValue("update")

    this.acceptOperation(response)
  }

  acceptOperation(response: any)
  {
    if(Result.isKind(response) && response.result == 1)
    {
      this.dialogRef.close
      (
        {
          code: DialogsReturnCode.SLOT_OPERATION_ACCEPTED
        }
      )
    }
  }

  cancel() {
    this.dialogRef.close
      (
        {
          code: DialogsReturnCode.OPERATION_DECLINED
        }
      )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue(action:string)
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return

    this._loader.start()

    const params =  this.createParams()

    this._slot.mode = "WEBCC"
    this._slot.os = this._deviceInfo.getDeviceInfo().os + " " + this._deviceInfo.getDeviceInfo().osVersion
    this._slot.swVersion = version.value
    this._slot.browser = this._deviceInfo.getDeviceInfo().browser + " " + this._deviceInfo.getDeviceInfo().browserVersion

    let response = null
    if(action === "create") response = await this._handler.slot().createPrenotation((user as User).token, this.site.organizationId, this.service.id, this._slot, params)
    if(action === "update") response = await this._handler.slot().updatePrenotation((user as User).token, this.site.organizationId, this.service.id, this._slot, params)

    this._loader.stop()

    return response
  }
  //---------------------------------------------------------------------------------------------------

  createParams () {
    return [
      { k: "SITE_NAME"    , v: this.getAQPSiteName()                                      },
      { k: "SITE_ADDRESS" , v: this.site.address                                          },
      { k: "SERVICE_NAME" , v: this.getAQPServiceName()                                   },
      { k: "DATE"         , v: this._util.date().toFormat(this.date, "dd/MM/yyyy", "it")  },
      { k: "TIME"         , v: this._slot.timeBegin                                       },
      { k: "BOOK_CODE"    , v: this._slot?.bookCode                                       }
    ]
  }

  getAQPSiteName(){
    if(!this.site || !this.site.name) return  ""
    try{
      const onlyName = this.site.name.substring(19)
      if(onlyName.length > 14)
        return onlyName.substring(0, 14)
      return onlyName
    }catch(error){
      return this.site.name
    }
  }

  getAQPServiceName(){
    if(!this.service || !this.service.name) return  ""
    try{
      return this.service.name.substring(0, 16)
    }catch(error){
      return this.service.name
    }
  }
}
